import FieldNames from "../defaults/FieldNames.json";
import ErrorService from "../services/ErrorService";
import FeatureService from "../services/FeatureService";
import FundingService from "../services/FundingService";

import moment from 'moment-timezone';

export async function getFundingByFeatureIDs (isLimitedToSelected, selectedFeatures, featureIDs, rootServiceUrl, config) {
  try
  {
    let results = [];
    let selectedItems = featureIDs;
  
    if(isLimitedToSelected){
      selectedItems = selectedFeatures?.map(x => x.ID);
    }
  
    if(selectedItems && selectedItems.length > 0){
      const fundingResults = await FundingService.getFundingByJoinIDs(rootServiceUrl, selectedItems, config).then(fundingResults => {
        return fundingResults;
      });
      results = fundingResults;
    }
      
    return results;
  }
  catch(error)
  {
    return new Promise((resolve,reject) => {
      reject(error);
    });
  }
}

// TODO: Currently unused. Delete by 1.8 if no use case found.
export function getFundingByJoinIDsPromise (features, joinIds, rootServiceUrl, config, definitionExpression = null, outFields="*") {
  return new Promise((resolve, reject) => {
    let results = {
      treatments: [],
      activities: [],
      actualTreatments: [],
      actualActivities: []
    };
  
    getFeatureFundingByIdPromise(joinIds).then((fundingList) => {
      resolve(fundingList);
    }).catch(error => {
      reject(error);
    });
      
    function getFeatureFundingByIdPromise(itemList) {
      return new Promise((resolve, reject) => {
        if(itemList && itemList.length > 0)
        {
          FundingService.getFundingByBatchedFeatureJoinIDs(rootServiceUrl, itemList, config, definitionExpression, outFields).then(fundingResults => {
            resolve(fundingResults);
          }).catch(error => {
            reject(error);
          });
        }
        else
        {
          resolve([]);
        }
      });
    }
  });
}

export function isEmpty(value) {
  return (value == null || (typeof value === "string" && value.trim().length === 0));
}

export function buildInitialEntryWhenMultiple (featureObject) {
  const featureFields = FieldNames.fundingFields;
  featureObject[featureFields.fundingDepartment] = (featureObject?.[featureFields.fundingDepartment]?.includes("|")) ? "Multiple Funding Departments" : featureObject[featureFields.fundingDepartment];
  featureObject[featureFields.fundingAgency] = (featureObject?.[featureFields.fundingAgency]?.includes("|")) ? "Multiple Funding Agencies" : featureObject[featureFields.fundingAgency];
  featureObject[featureFields.fundingRegion] = (featureObject?.[featureFields.fundingRegion]?.includes("|")) ? "Multiple Funding Regions" : featureObject[featureFields.fundingRegion];
  featureObject[featureFields.fundingUnit] = (featureObject?.[featureFields.fundingUnit]?.includes("|")) ? "Multiple Funding Units" : featureObject[featureFields.fundingUnit];
  featureObject[featureFields.fundingTribe] = (featureObject?.[featureFields.fundingTribe]?.includes("|")) ? "Multiple Funding Tribes" : featureObject[featureFields.fundingTribe];
  featureObject[featureFields.fundingUnitType] = (featureObject?.[featureFields.fundingUnitType]?.includes("|")) ? "Multiple Funding Unit Types" : featureObject[featureFields.fundingUnitType];
  featureObject[featureFields.fundingUnitID] = (featureObject?.[featureFields.fundingUnitID]?.includes("|")) ? "Multiple Funding Unit IDs" : featureObject[featureFields.fundingUnitID];
  featureObject[featureFields.fundingSubUnit] = (featureObject?.[featureFields.fundingSubUnit]?.includes("|")) ? "Multiple Funding SubUnits" : featureObject[featureFields.fundingSubUnit];
  featureObject[featureFields.fundingSource] = (featureObject?.[featureFields.fundingSource]?.includes("|")) ? "Multiple Funding Sources" : featureObject[featureFields.fundingSource];
  featureObject[featureFields.fundingSourceProgram] = (featureObject?.[featureFields.fundingSourceProgram]?.includes("|")) ? "Multiple Funding Source Programs" : featureObject[featureFields.fundingSourceProgram];
  featureObject[featureFields.fundingSourceCategory] = (featureObject?.[featureFields.fundingSourceCategory]?.includes("|")) ? "Multiple Funding Source Categories" : featureObject[featureFields.fundingSourceCategory];
  featureObject[featureFields.fundingSourceSubCategory] = (featureObject?.[featureFields.fundingSourceSubCategory]?.includes("|")) ? "Multiple Funding Source SubCategories" : featureObject[featureFields.fundingSourceSubCategory];
  featureObject[featureFields.contributedNotes] = (featureObject?.[featureFields.contributedNotes]?.includes("|")) ? "Multiple Contributed Notes" : featureObject[featureFields.contributedNotes];
  featureObject[featureFields.costCenter] = (featureObject?.[featureFields.costCenter]?.includes("|")) ? "Multiple Cost Centers" : featureObject[featureFields.costCenter];
  featureObject[featureFields.costCode] = (featureObject?.[featureFields.costCode]?.includes("|")) ? "Multiple Cost Codes" : featureObject[featureFields.costCode];
  featureObject[featureFields.functionalArea] = (featureObject?.[featureFields.functionalArea]?.includes("|")) ? "Multiple Functional Areas" : featureObject[featureFields.functionalArea];
  return featureObject;
}

export function buildFeatureWithFunding (featureObject, costEntry) {
  featureObject[FieldNames.featureFields.fundingDepartment] = costEntry[FieldNames.fundingFields.fundingDepartment];
  featureObject[FieldNames.featureFields.fundingAgency] = costEntry[FieldNames.fundingFields.fundingAgency];
  featureObject[FieldNames.featureFields.fundingRegion] = costEntry[FieldNames.fundingFields.fundingRegion];
  featureObject[FieldNames.featureFields.fundingUnit] = costEntry[FieldNames.fundingFields.fundingUnit];
  featureObject[FieldNames.featureFields.fundingTribe] = costEntry[FieldNames.fundingFields.fundingTribe];
  featureObject[FieldNames.featureFields.fundingUnitType] = costEntry[FieldNames.fundingFields.fundingUnitType];
  featureObject[FieldNames.featureFields.fundingUnitID] = costEntry[FieldNames.fundingFields.fundingUnitID];
  featureObject[FieldNames.featureFields.fundingSubUnit] = costEntry[FieldNames.fundingFields.fundingSubUnit];
  featureObject[FieldNames.featureFields.fundingSource] = costEntry[FieldNames.fundingFields.fundingSource];
  featureObject[FieldNames.featureFields.fundingSourceProgram] = costEntry[FieldNames.fundingFields.fundingSourceProgram];
  featureObject[FieldNames.featureFields.fundingSourceCategory] = costEntry[FieldNames.fundingFields.fundingSourceCategory];
  featureObject[FieldNames.featureFields.fundingSourceSubCategory] = costEntry[FieldNames.fundingFields.fundingSourceSubCategory];
  featureObject[FieldNames.featureFields.estimatedAssetCost] = costEntry[FieldNames.fundingFields.assetCost];
  featureObject[FieldNames.featureFields.estimatedContractualCost] = costEntry[FieldNames.fundingFields.contractualCost];
  featureObject[FieldNames.featureFields.estimatedOtherCost] = costEntry[FieldNames.fundingFields.otherCost];
  featureObject[FieldNames.featureFields.estimatedGrantsFixedCost] = costEntry[FieldNames.fundingFields.grantsFixedCost];
  featureObject[FieldNames.featureFields.estimatedPersonnelCost] = costEntry[FieldNames.fundingFields.personnelCost];
  featureObject[FieldNames.featureFields.estimatedTotalCost] = costEntry[FieldNames.fundingFields.totalCost];
  featureObject[FieldNames.featureFields.contributedNotes] = costEntry[FieldNames.fundingFields.notes];
  featureObject[FieldNames.featureFields.costCenter] = costEntry[FieldNames.fundingFields.costCenter];
  featureObject[FieldNames.featureFields.costCode] = costEntry[FieldNames.fundingFields.costCode];
  featureObject[FieldNames.featureFields.functionalArea] = costEntry[FieldNames.fundingFields.functionalArea];
  featureObject[FieldNames.featureFields.calculatedArea] = costEntry[FieldNames.fundingFields.acres];
  return featureObject;
}

export function ResetFeatureFundingLinesByFeature(feature, userInfo) {
  try
  {
    if(!feature){
      throw Error("Missing feature to calculate default funding acreage")
    }

    const featureObj = feature.attributes ?? feature;
    //This will be the JoinID field on anything that isn't a view and ID on anything that is a view
    const joinID = featureObj[FieldNames.featureFields.joinID] ? featureObj[FieldNames.featureFields.joinID] : featureObj[FieldNames.featureFields.id];
    const joinFeature = featureObj[FieldNames.featureFields.joinFeature] ? featureObj[FieldNames.featureFields.joinFeature] : FieldNames.joinFeatureValues.polygon;
    const calculatedArea = featureObj[FieldNames.featureFields.calculatedArea];
    const outFields = "OBJECTID, FundingSourceProgram, TotalCost, Acres";
    return FundingService.getFundingByJoinID(joinID, joinFeature, outFields).then(resp => {
      let fundingRows = [];
      resp.forEach(fundingItem => {
        const obj = {
          [FieldNames.featureFields.objectID]: fundingItem[FieldNames.featureFields.objectID],
          [FieldNames.fundingFields.fundingSourceProgram]: fundingItem[FieldNames.fundingFields.fundingSourceProgram],
          [FieldNames.fundingAcreageFields.acres]: fundingItem[FieldNames.fundingAcreageFields.acres],
          [FieldNames.fundingFields.totalCost]: fundingItem[FieldNames.fundingFields.totalCost],
        }
        fundingRows.push(obj);
      })

      let updatedRows = CalculateDefaultFundingAcres(fundingRows, calculatedArea);
      let relevantUpdates = updatedRows.map(row => {
        let rowObj = {}
        rowObj[FieldNames.featureFields.objectID] = row[FieldNames.featureFields.objectID];
        rowObj[FieldNames.fundingAcreageFields.acres] = row[FieldNames.fundingAcreageFields.acres];
        return rowObj;
      }) 
  
      return FundingService.updateFundingEntries(relevantUpdates).then((response) => {
        if (
          response &&
          response.updateResults &&
          response.updateResults.length > 0 &&
          response.updateResults[0].success
        ) {
          const featureUpdateObj = {
            [FieldNames.featureFields.objectID]: featureObj[FieldNames.featureFields.objectID],
            [FieldNames.featureFields.isFundingAcresManual]: FieldNames.yesNo.no
          }
          featureObj[FieldNames.featureFields.isFundingAcresManual] = FieldNames.yesNo.no;

          FeatureService.updateFeatureAttributes([featureUpdateObj]).then(response => {
            return updatedRows
          }).catch(error => {
            ErrorService.addErrorLogEntry(userInfo[FieldNames.userFields.nifcUsername], error);
            return updatedRows;
          });
          return updatedRows;
        } else {
          return [];
        }
      });
    });
  }
  catch(e)
  {
    return new Promise((resolve,reject) => {
      reject(e);
    });
  }
}

export function ResetFeatureFundingLinesByFunding(rootServiceUrl, config, nifcToken, feature, fundingLines, userInfo) {
  try
  {
    if(!fundingLines || !feature){
      throw Error("Missing feature/funding to calculate default funding acreage")
    }

    const featureObj = feature.attributes ?? feature;
    const calculatedArea = featureObj[FieldNames.featureFields.calculatedArea];
    let updatedRows = CalculateDefaultFundingAcres(fundingLines, calculatedArea);
    let relevantUpdates = updatedRows.map(row => {
      let rowObj = {}
      rowObj[FieldNames.featureFields.objectID] = row[FieldNames.featureFields.objectID];
      rowObj[FieldNames.fundingAcreageFields.acres] = row[FieldNames.fundingAcreageFields.acres];
      return rowObj;
    }) 

    return FundingService.updateFundingEntries(relevantUpdates).then((response) => {
      if (
        response &&
        response.updateResults &&
        response.updateResults.length > 0 &&
        response.updateResults[0].success
      ) {
        const featureUpdateObj = {
          [FieldNames.featureFields.objectID]: featureObj[FieldNames.featureFields.objectID],
          [FieldNames.featureFields.isFundingAcresManual]: FieldNames.yesNo.no
        }

        FeatureService.updateFeatureAttributes([featureUpdateObj]).then(response => {
          return updatedRows
        }).catch(error => {
          ErrorService.addErrorLogEntry(userInfo[FieldNames.userFields.nifcUsername], error);
          return updatedRows;
        });
      } else {
        return [];
      }
    });
  }
  catch(e)
  {
    return new Promise((resolve,reject) => {
      reject(e);
    });
  }
}

export function CalculateDefaultFundingAcres(fundingLines, calculatedArea) {
  if(!fundingLines || fundingLines?.length === 0)
  {
    return [];
  }
  let updatedFundingLines = [];
  const areAllRowsContributed = fundingLines?.length > 0 && 
                                  fundingLines.filter(x => x[FieldNames.fundingFields.fundingSourceProgram] 
                                    === FieldNames.fundingSourcePrograms.contributed).length === fundingLines?.length;

  // Right now this is only Fuels as an alternative, but for future-proofing, keep it as non-contributed
  let nonContributedFundingLines = fundingLines.filter(x => x[FieldNames.fundingFields.fundingSourceProgram] 
                                  !== FieldNames.fundingSourcePrograms.contributed &&
                                    x[FieldNames.fundingFields.totalCost] !== 0);
  let contributedFundingLines = fundingLines.filter(x => x[FieldNames.fundingFields.fundingSourceProgram] 
                                  === FieldNames.fundingSourcePrograms.contributed &&
                                    x[FieldNames.fundingFields.totalCost] !== 0);
  let zeroTotalCostLines = fundingLines.filter(x => x[FieldNames.fundingFields.totalCost] === 0);

  let totalCosts = 0;
  let rowsToUpdate = [];
  let rowsToEmpty = [];

  // Contributed lines should only be counted if all rows are contributed
  if(areAllRowsContributed)
  {
    rowsToUpdate = contributedFundingLines;
    rowsToEmpty = zeroTotalCostLines;
  }
  else
  {
    rowsToUpdate = nonContributedFundingLines;
    rowsToEmpty = zeroTotalCostLines.concat(contributedFundingLines);
  }

  // Calculate split costs for relevant rows
  totalCosts = rowsToUpdate.map(row => row[FieldNames.fundingFields.totalCost]).reduce((a, b) => a + b, 0);
  rowsToUpdate.map(row => {
    const rowCost = row[FieldNames.fundingFields.totalCost];
    if(!rowCost || !totalCosts)
    {
      return row;
    }
    const calculatedPercentage = rowCost / totalCosts;
    const roundedAcres = Math.round(calculatedArea * calculatedPercentage);
    row[FieldNames.fundingAcreageFields.acres] = roundedAcres;
    return row;
  });

  rowsToEmpty.map(row => {
    row[FieldNames.fundingAcreageFields.acres] = 0;
    return row;
  })

  updatedFundingLines = updatedFundingLines.concat(rowsToUpdate);
  updatedFundingLines = updatedFundingLines.concat(rowsToEmpty);

  return updatedFundingLines;
}

export function isFundingCellEditable(params, editableFeature, areAllRowsContributed){
  return params?.field === FieldNames.fundingAcreageFields.acres &&
            (params?.row[FieldNames.fundingFields.fundingSourceProgram] !== FieldNames.fundingSourcePrograms.contributed
              || areAllRowsContributed) && (editableFeature != null && editableFeature?.attributes[FieldNames.featureFields.isPoint] !== FieldNames.yesNo.yes && params?.row[FieldNames.fundingFields.joinFeature] === FieldNames.joinFeatureValues.polygon)
}